import { Stack, Box, Typography, Divider } from "@mui/material";
import { CommandCenterHeader } from "@components";
import { useWebApiV1GetUserPreferencesQuery } from "@providers/hop-ord-server/api";
import { Role } from "@enums";
import { useNavigate } from "react-router-dom";
import { ServerStatusCard } from "./components/ServerStatusCard";
import { JobsOverviewCard } from "./components/JobsOverviewCard";
import { useCheckUserRole } from "@utils/useCheckUserRole";

const DeploymentDashboard = () => {
  const navigate = useNavigate();
  const { data: userPreferenceData } = useWebApiV1GetUserPreferencesQuery();

  const tenantIds = userPreferenceData?.tenant_ids;

  // Check if user has automation deployment role
  const hasDeploymentAccess = useCheckUserRole(Role.AUTOMATION_DEPLOYMENT);

  // If user doesn't have deployment role, show error page
  if (!hasDeploymentAccess) {
    navigate("/error");
  }

  return (
    <Stack
      height={1}
      maxHeight={1}
      width={1}
      maxWidth="1700px"
      marginLeft="auto"
      marginRight="auto"
    >
      <Box sx={{ padding: 2, paddingBottom: 0 }}>
        <CommandCenterHeader title="Deployment Dashboard" />
      </Box>
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: 2,
          paddingTop: 0,
        }}
      >
        <Stack gap={3}>
          {/* Server Status Overview */}
          <ServerStatusCard />

          {/* Jobs Overview */}
          <JobsOverviewCard />

          {tenantIds && (
            <>
              <Divider />
              <Typography variant="caption" color="text.secondary">
                Connected tenant IDs: {tenantIds.join(", ")}
              </Typography>
            </>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};

export default DeploymentDashboard;
